import { DictionaryEntry } from "@sdbn/common";

export class Message {

    id: number;
    name: string;

    constructor(message?: any) {
        if (message != null) {
            this.id = message.id;
            this.name = message.name;
        }
    }

}